import React, { useState } from 'react';
import { MatchPeople } from './MatchPeople';
import { TopicDetail } from './TopicDetail';
import { PageHeader } from '../components/PageHeader';
import { useLanguage } from '../components/LanguageContext';
export function ScopriContainer() {
  const {
    t
  } = useLanguage();
  const [selectedTopicId, setSelectedTopicId] = useState<string | null>(null);
  if (selectedTopicId) {
    return <TopicDetail topicId={selectedTopicId} onBack={() => setSelectedTopicId(null)} data-id="element-909" />;
  }
  return <div className="flex flex-col h-full w-full bg-[#0D0D0D] overflow-hidden" data-id="element-910">
      <PageHeader title={t('match.tab.discover')} data-id="element-911" />
      <div className="flex-1 overflow-hidden min-h-0" data-id="element-912">
        <MatchPeople onSelectTopic={id => setSelectedTopicId(id)} data-id="element-913" />
      </div>
    </div>;
}